// División político-administrativa de Colombia (departamentos y municipios, DIVIPOLA/DANE).
// El dataset crudo (32 departamentos, 1104 municipios; Bogotá D.C. figura dentro de
// Cundinamarca) vive en `colombia.divipola.json` y se importa tal cual (Next.js soporta
// import de JSON). Se usa para los selects en cascada de «¿Quién interpone la notificación
// disciplinaria?» (Etapa 2, Libro radicador).
import raw from './colombia.divipola.json';

interface DivipolaItem { id: number; departamento: string; ciudades: string[]; }

const DATA = raw as DivipolaItem[];

/** Municipios por departamento (clave = nombre exacto del departamento), ordenados A→Z. */
export const MUNICIPIOS_POR_DEPARTAMENTO: Record<string, readonly string[]> = Object.fromEntries(
  DATA.map((d) => [d.departamento, [...d.ciudades].sort((a, b) => a.localeCompare(b, 'es'))]),
);

/** Departamentos en orden alfabético. */
export const DEPARTAMENTOS: readonly string[] = Object.keys(MUNICIPIOS_POR_DEPARTAMENTO)
  .sort((a, b) => a.localeCompare(b, 'es'));

/** Municipios de un departamento (vacío si no existe o no se ha elegido). */
export function municipiosDe(departamento: string): readonly string[] {
  return MUNICIPIOS_POR_DEPARTAMENTO[departamento] ?? [];
}
